module.exports = __webpack_public_path__ + "static/img/22c.27fc062.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22c.jpg
// module id = MgIY
// module chunks = 0